class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.giftWrapProductId = this.dataset.giftWrapId;
    this.isGiftWrappingEnabled = this.dataset.giftWrapping;
    this.cartItemCount = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapItemCount = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.totalItemCount = parseInt(this.getAttribute('items-in-cart'));
    this.giftWrapMode = this.dataset.giftWrappingLimit;
  }

  connectedCallback() {
    setTimeout(() => {
      this.initializeGiftWrapCheckbox();
      this.handleInitialGiftWrapState();
    }, 100);
  }

  initializeGiftWrapCheckbox() {
    const checkbox = this.querySelector('[name="attributes[gift-wrapping]"]');
    if (checkbox) {
      if (checkbox.checked && this.giftWrapItemCount == 0) {
        checkbox.checked = false;
      }
      
      checkbox.addEventListener('change', (event) => {
        event.target.checked ? this.addGiftWrap() : this.removeGiftWrap();
      });

      if (this.isGiftWrappingEnabled && this.isGiftWrappingEnabled.length > 0 && this.giftWrapItemCount == 0) {
        setTimeout(() => {
          this.removeGiftWrapAttributes();
        }, 500);
      }
    }
  }

  handleInitialGiftWrapState() {
    if (this.cartItemCount == 1 && this.giftWrapItemCount > 0) {
      return this.removeGiftWrap();
    }
    
    if (this.giftWrapItemCount > 0 && (!this.isGiftWrappingEnabled || this.isGiftWrappingEnabled.length == 0)) {
      return this.addGiftWrap();
    }
    
    if (this.giftWrapItemCount == 0 && this.isGiftWrappingEnabled && this.isGiftWrappingEnabled.length > 0) {
      return this.removeGiftWrapAttributes();
    }
  }

  addGiftWrap() {
    if (!this.giftWrapProductId) {
      return;
    }
    
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 1,
      },
      { 'gift-wrapping': true },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }

  removeGiftWrap() {
    if (!this.giftWrapProductId) {
      return;
    }
    
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 0,
      },
      { 'gift-wrapping': '', 'gift-note': '' },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }

  removeGiftWrapAttributes() {
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {},
      { 'gift-wrapping': '', 'gift-note': '' },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }

  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  createRequestBody(updates, attributes, sections) {
    return JSON.stringify({ updates, attributes, sections });
  }

  updateCart(body) {
    if (!FoxTheme || !FoxTheme.routes || !FoxTheme.routes.cart_update_url) {
      return;
    }

    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((parsedState) => {
        if (FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
        }
      })
      .catch((error) => {
        console.error(error);
        this.hideLoader();
      });
  }

  showLoader() {
    const loaderElement = this.querySelector('.loader');
    if (loaderElement) loaderElement.classList.add('btn--loading');
  }

  hideLoader() {
    const loaderElement = this.querySelector('.loader');
    if (loaderElement) loaderElement.classList.remove('btn--loading');
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme && FoxTheme.utils && FoxTheme.utils.debounce) {
      this.addEventListener('change', FoxTheme.utils.debounce(this.updateGiftNote.bind(this), 300));
    } else {
      this.addEventListener('change', this.updateGiftNote.bind(this));
    }
  }

  updateGiftNote(event) {
    if (!FoxTheme || !FoxTheme.routes || !FoxTheme.routes.cart_update_url) {
      return;
    }

    const requestBody = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body: requestBody } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((parsedState) => {
        if (FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}
customElements.define('gift-note', GiftNote);

class RemoveGiftWrapButton extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const isInCartDrawer = this.closest('cart-drawer') !== null || this.closest('.cart-drawer') !== null;
      
      if (isInCartDrawer) {
        const cartItemsElement = this.closest('cart-items');
        if (cartItemsElement && typeof cartItemsElement.updateQuantity === 'function') {
          cartItemsElement.updateQuantity(this.dataset.index, 0);
        } else {
          this.removeGiftWrapItemDirectly();
        }
      } else {
        const cartItemsElement = this.closest('cart-items');
        if (cartItemsElement && cartItemsElement.showLoader) {
          cartItemsElement.showLoader(this.dataset.index);
        }

        const giftWrappingElement = document.querySelector('gift-wrapping');
        if (giftWrappingElement && typeof giftWrappingElement.removeGiftWrap === 'function') {
          giftWrappingElement.removeGiftWrap();
        } else {
          this.removeGiftWrapItemDirectly();
        }
      }
    });
  }

  removeGiftWrapItemDirectly() {
    const itemIndex = this.dataset.index;
    if (!itemIndex) {
      return;
    }

    const requestBody = JSON.stringify({
      updates: { [itemIndex]: 0 }
    });

    fetch(`${FoxTheme.routes.cart_update_url}`, { 
      ...FoxTheme.utils.fetchConfig(), 
      body: requestBody 
    })
    .then((response) => response.json())
    .then((parsedState) => {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
    })
    .catch((error) => {
      console.error(error);
    });
  }
}
customElements.define('gift-wrap-remove-item', RemoveGiftWrapButton, { extends: 'a' });
